enum LoginsActionTypes {
	GET_LOGIN_INFO = "GET_LOGIN_INFO",
}

export default LoginsActionTypes;
